import { BaseOrderEntity, IBaseOrder } from './base-order.model';
import { EasyState, EasyValidityTypeCode } from './orderModels.model';
import { OrderConstants, OrderModelType, OrderStateClasses } from '../../../../constants';
import { IBaseEntity } from '../../../shared/models/base.model';
import { DateHelper } from '../../../../tools';

export class DraftOrder extends BaseOrderEntity<DraftOrder> {
	constructor(obj: Partial<DraftOrder>) {
		super(obj);
		Object.assign(this, obj);
		this.orderModelType = OrderModelType.draft;
	}
	cautionAgreementSelected?: boolean;

	get IsWaiting(): boolean {
		return this.easyState !== EasyState.Done;
	}

	get IsSelectable() {
		return true;
	}
	get IsSendAndCopyValid(): boolean {
		return this.easyState === EasyState.Done;
	}

	get StateClass() {
		return this.easyState === EasyState.Done ? OrderStateClasses.Draft : OrderStateClasses.Disabled;
	}

	get StateNotificationClass() {
		return this.StateNotificationColorClass;
	}

	get StateNotificationColorClass() {
		return this.easyState !== EasyState.Done ? 'text-secondary' : 'text-warning';
	}

	get StateNotificationText() {
		if (this.easyState !== EasyState.Done) return 'پیش‌نویس ' + OrderConstants.EasyStateToText[this.easyState];
		return 'پیش نویس';
	}

	get IsOrderValidToDate(): boolean {
		return [
			EasyValidityTypeCode.ValidToDate,
			EasyValidityTypeCode.Month,
			EasyValidityTypeCode.Week,
			EasyValidityTypeCode.ValidToCancellation
		].includes(this.validityType);
	}

	get ValidityDateTitle(): string {
		if (this.validityType === EasyValidityTypeCode.ValidToCancellation) return 'معتبر تا لغو';
		if (this.IsOrderValidToDate) return 'معتبر تا ' + DateHelper.getFormattedJDate(new Date(this.validityDate));
		return 'روز';
	}

	get IsDeleteValid() {
		return this.easyState === EasyState.Done;
	}
	get IsEditValid() {
		return this.easyState === EasyState.Done;
	}
}

export interface IDraftOrderUpdateRequest extends IBaseEntity, IBaseOrder {}
export interface IDraftOrderUpdateResponse extends IBaseEntity, IBaseOrder {}
export type IDraftOrderCreateRequest = IBaseOrder;
export interface IDraftOrderCreateResponse extends IBaseEntity, IBaseOrder {}
export type IDraftOrderDeleteRequest = IBaseEntity;
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IDraftOrderDeleteResponse {}
